export class InformacionGeneral {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                header: 'Código',
            },
            fecha: {
                value: new Date(),
                header: 'Fecha (día/mes/año):',
                required: 'Fecha es requerido',
            },
            tipo_estructura: {
                value: null,
                header: 'TIPO / ESTRUCTURA LEGAL',
                required: 'Campo requerido'
            },
            apellido_paterno: {
                value: '',
                header: 'Apellido Paterno:',
                required: 'Campo requerido',
                maxLength: 'Máximo 250 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 250,
                min: 4,
            },
            apellido_materno: {
                value: '',
                header: 'Apellido Materno:',
                required: 'Campo requerido',
                maxLength: 'Máximo 250 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 250,
                min: 4,
            },
            nombres: {
                value: '',
                header: 'Nombres:',
                required: 'Campo requerido',
                maxLength: 'Máximo 250 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 250,
                min: 4,
            },
            tipo_identificacion: {
                value: null,
                header: 'Tipo de documento:',
                required: 'Tipo de formulario es requerido'
            },
            identificacion: {
                value: '',
                header: 'No. de Identificación:',
                required: 'Identificación es requerido',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4,
            },
            fecha_nacimiento: {
                value: new Date(),
                header: 'Fecha de nacimiento (día/mes/año):',
                required: 'Fecha de nacimiento es requerido'
            },
            edad: {
                value: null,
                header: 'Edad:',
                required: 'Edad es requerida'
            },
            genero: {
                value: null,
                header: 'Género:',
                required: 'Género es requerido'
            },
            estado_civil: {
                value: null,
                header: 'Estado civil:',
                required: 'Estado civil es requerido'
            },
            nacionalidad: {
                value: null,
                header: 'Nacionalidad:',
                required: 'Nacionalidad es requerido.'
            },
            pais_residencia: {
                value: null,
                header: 'País de residencia:',
                required: 'País es requerido'
            },
            provincia_residencia: {
                value: null,
                header: 'Provincia de residencia:',
                required: 'Provincia es requerido'
            },
            ciudad_residencia: {
                value: null,
                header: 'Ciudad de residencia:',
                required: 'Ciudad es requerida'
            },
            canton_residencia: {
                value: '',
                header: 'Ciudad:',
                maxLength: 'Máximo 250 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 250,
                min: 4,
                required: 'Ciudad es requerida'
            },
            direccion_residencia: {
                value: '',
                header: 'Dirección de residencia:',
                maxLength: 'Máximo 500 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 500,
                min: 4,
                required: 'Campo requerido'
            },
            telefono: {
                value: '',
                header: 'Teléfono:',
                maxLength: 'Máximo 40 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 40,
                min: 4,
                required: 'Teléfono es requerida'
            },
            fax: {
                value: '',
                header: 'Fax:',
                maxLength: 'Máximo 40 caracteres',
                minLength: 'Mínimo 3 caracteres',
                max: 40,
                min: 3
            },
            celular: {
                value: '',
                header: 'Celular:',
                maxLength: 'Máximo 40 caracteres',
                minLength: 'Mínimo 3 caracteres',
                max: 40,
                min: 3,
                required: 'Celular es requerido'
            },
            email: {
                value: '',
                header: 'E-Mail:',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 200,
                min: 4
            },
            profesion: {
                value: '',
                header: 'Profesión:',
                required: 'Profesión es requerida',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
            },
            ruc: {
                value: '',
                header: 'RUC:',
                required: 'RUC es requerido',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4,
            },
            sector_economico: {
                value: '',
                header: 'Sector económico:',
                required: 'Campo requerido',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 200,
                min: 4,
            },
            ingreso_promedio: {
                value: 0,
                header: 'Ingreso promedio mensual USD:',
                required: 'Valor requerido.'
            },
            actividad_economica: {
                value: null,
                header: 'Actividad económica:',
                required: 'Actividad económica es requerida'
            },
            fecha_inicio_actividad_profesional: {
                value: new Date(),
                header: 'Fecha de inicio de actividad profesional (día/mes/año):',
                required: 'Fecha es requerido',
            },
        }
    }

    optionLabel = 'nombre';
    pattern = { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, message: 'Correo no válido. E.g. example@email.com' };
}
